import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, PartyDto, PartyReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import PartyInline, { PartyInlineProps } from "./PartyInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: PartyDto | PartyReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<PartyInlineProps>;
}

export default function PartyLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess]}
      to={ROUTE_PATH.PARTY_VIEW(entity?.id || entityId || "")}
      content={<PartyInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
